export enum OrderReturnReason {
  APPLICATION_ERROR = 'APPLICATION_ERROR',
  PURCHASE_REGRET = 'PURCHASE_REGRET',
  PART_WARRANTY = 'PART_WARRANTY',
  LATE_DELIVERY = 'LATE_DELIVERY',
  STOCK_BREAK = 'STOCK_BREAK',
  PRODUCT_PROBLEM = 'PRODUCT_PROBLEM',
  CHANGED_MIND = 'CHANGED_MIND',
  CANCELED_ORDER = 'CANCELED_ORDER',
  OTHERS = 'OTHERS',
}
